/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { TokenConfig, MintResult, TokenMetadata } from '../types/tokens';
import { tokenStore } from '../server/data/minted-tokens';

export const submitTokenLaunch = async (
    config: TokenConfig, 
    mintResult: MintResult
): Promise<{ success: boolean; id?: string }> => {
    
    console.log("[API] Submitting new token launch to indexer...", config.ticker);
    
    // Simulate API delay
    await new Promise(r => setTimeout(r, 600));

    // Construct metadata record
    const newTokenRecord: TokenMetadata = {
        id: mintResult.mintAddress,
        name: config.name,
        symbol: config.ticker,
        description: config.description || "",
        image: config.imageUrl || "",
        header_image: config.headerImageUrl,
        tags: config.tags,
        properties: {
            chain: config.chain,
            network: config.network,
            mintAddress: mintResult.mintAddress,
            txHash: mintResult.txHash,
            createdAt: Date.now(),
            tokenStandard: config.tokenStandard,
            extensions: config.extensions,
            website: config.website,
            twitter: config.twitter,
            telegram: config.telegram,
            discord: config.discord
        }
    };

    // Save to our mock DB
    tokenStore.add(newTokenRecord);

    return { success: true, id: mintResult.mintAddress };
};